"use client";

import * as Sentry from "@sentry/nextjs";
import NextError from "next/error";
import { useEffect } from "react";

interface Props {
  error: Error & { digest?: string };
}

export default function GlobalError(props: Props) {
  const { error } = props;

  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="en">
      <body>
        <NextError statusCode={undefined as unknown as number} />
      </body>
    </html>
  );
}
